import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  listarProductos, crearProducto, editarProducto, eliminarProducto, type EntradaProducto,
} from '../lib/api/productos';
import { qk } from './keys';

export function useProductos() {
  return useQuery({ queryKey: qk.productos, queryFn: listarProductos });
}

export function useCrearProducto() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: EntradaProducto) => crearProducto(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.productos });
      qc.invalidateQueries({ queryKey: qk.movimientos });
      qc.invalidateQueries({ queryKey: qk.dashboard });
    },
  });
}

export function useEditarProducto() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: EntradaProducto }) => editarProducto(id, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.productos });
      qc.invalidateQueries({ queryKey: qk.inventario });
      qc.invalidateQueries({ queryKey: qk.alertas });
      qc.invalidateQueries({ queryKey: qk.movimientos });
    },
  });
}

export function useEliminarProducto() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => eliminarProducto(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.productos });
      qc.invalidateQueries({ queryKey: qk.inventario });
      qc.invalidateQueries({ queryKey: qk.alertas });
      qc.invalidateQueries({ queryKey: qk.movimientos });
      qc.invalidateQueries({ queryKey: qk.dashboard });
    },
  });
}
